import { Site } from '../site';

Site.initializeFoundation();

$(document).ready(function() {
  $.ajax({
    type: 'GET',
    url: 'https://api.ipgeolocation.io/ipgeo?apiKey='+GEO,
    success: function(data) {
      
      document.querySelector('form input[name="00N5i00000ClpKr"]').value = data.time_zone.name;
      document.querySelector('form input[name="00N5i00000ClpLQ"]').value = (new Date().toISOString()).split('.')[0].replace('T', ' ');
      document.querySelector('form input[name="00N5i00000CnLjF"]').value = data.ip;
      document.querySelector('form input[name="00N5i00000JPJJz"]').value = data.zipcode;

      document.querySelector('form input[name="00N5i000009uP1H"]').value = data.country_name;
      document.querySelector('form input[name="00N5i00000JPIOy"]').value = data.country_code2;

      document.querySelector('form input[name="00N5i00000CnM15"]').value = data.latitude;
      document.querySelector('form input[name="00N5i00000CnM1K"]').value = data.longitude;

      document.querySelector('form input[name="00N5i000009uOiY"]').value = document.referrer || window.location.href;

    },
    error: function(error) {
      console.log('error ', error);
    }
  });

  if(!!MAINTENANCE){
    window.location.assign('https://contact.burstsms.com/upgrade?url='+window.location.href);
  }
});
